import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Table from '../../ui/Table';
import Tag from '../../ui/Tag';
import Input from '../../ui/Input';
import { useEffect, useState } from 'react';
import SortIcon from '../../assets/icons/SortIcon';
import { getUnvalidatedBounties, getUnvalidatedBountiesCount } from '../../apis/bounties/bounties';
import { dmyFormat } from '../../helpers/dateInDayMonthYearFormat';
import StatsCard from '../../ui/StatsCard';
import WhiteCard from '../../ui/WhiteCard';
import NoDataAvailable from '../../ui/NoDataAvailable';
import Loader from '../../ui/Loader';
import Pagination from '../../ui/Pagination';
import search from '../../assets/search.png';
import { useSearchParams } from 'react-router-dom';
import { BOUNTY_STATUS_TAG_COLOR } from '../../constants/datas';
import useLocalStorage from '../../hooks/useLocalStoarge';
import PopOver from '../../ui/PopOver';
import TabSwitching from '../../ui/TabSwitching';
import TruncatedTextWithTooltip from '../../ui/TruncatedTextWithTooltip';
import { useActiveProjectsEvents } from '../../hooks/useActiveProjectsEvents';
function ValidationOverview() {
    const [unvalidatedBounties, setUnvalidatedBounties] = useState([]);
    const [pageEntries, setPageEntries] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [searchParams] = useSearchParams();
    const [activeTab, handleActiveTab] = useActiveProjectsEvents('Projects', 'validationOverviewTab');

    const [isLoading, setIsLoading] = useState(true);
    const [searchString, setSearchString] = useState('');
    const { id } = useParams();

    const navigate = useNavigate();
    let filteredData = unvalidatedBounties;
    const page = !searchParams.get('page') ? 1 : Number(searchParams.get('page'));
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    setIsLoading(true);
                    const queryParams = {};
                    if (activeTab === 'Projects') {
                        queryParams.includeProjectBounties = true;
                        queryParams.includeIndividualBounties = true;
                    } else if (activeTab === 'Events') {
                        queryParams.includeEventBounties = true;
                    }

                    const countData = await getUnvalidatedBountiesCount(id, queryParams);
                    setTotalEntries(countData?.entryCount || 0);
                    const data = await getUnvalidatedBounties(id, currentPage, pageEntries, queryParams);
                    setUnvalidatedBounties(data);
                    setIsLoading(false);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [id, currentPage, pageEntries, activeTab]
    );

    const entriesHandler = (val) => {
        setPageEntries(val);
        setCurrentPage(1);
    };
    if (searchString)
        filteredData = filteredData.filter(
            ({ title, projectTitle }) =>
                title?.toLowerCase()?.includes(searchString?.toLowerCase()) ||
                projectTitle?.toLowerCase()?.includes(searchString?.toLowerCase())
        );



    return (
        <div>
            <div className="flex mt-6 items-center gap-4">
                <WhiteCard verticalMargin="" className="w-fit p-6 ">
                    <p className="font-semibold mb-2">Bounties</p>
                    <div className="flex items-center gap-4 ">
                        <StatsCard countHeading={'Current Total'} count={filteredData.length} />
                        <StatsCard
                            countHeading={'Pending Validation'}
                            count={filteredData.filter((d) => d?.status?.toLowerCase() === 'unvalidated').length}
                        />
                    </div>
                </WhiteCard>

                {/* <WhiteCard verticalMargin="" className="w-fit p-6 ">
                    <p className="font-semibold mb-2">Submissions</p>
                    <div className="flex items-center gap-6">
                        <StatsCard countHeading={'Pending Validation'} count={20} />
                    </div>
                </WhiteCard> */}
            </div>
            <Table className="gap-8" cols="grid-cols-tableValidationOverview">
                <div className="flex gap-10 mb-4 ">
                    <TabSwitching
                        activeTab={activeTab}
                        onSelectingActive={handleActiveTab}
                        firstTab={'Projects'}
                        secondTab={'Events'}
                        activeStyling={'text-textBrandBlue border-b-2 border-textBrandBlue '}
                        className={'text-xl font-medium pb-2'}
                    />
                </div>
                <div className="flex items-center w-[441px] gap-3 py-2 px-3 mb-4 border border-borderUnderline rounded-lg ">
                    <img className="w-6 h-6  object-cover" src={search} alt="" />
                    <Input
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                        placeholder="Search Bounty Title or Project Title"
                        className=" !w-full !border-0 !px-0 !py-0 outline-none "
                        containerClass="flex-1"
                        type="text"
                    />
                </div>
                <Table.Header>
                    <p className="text-sm   font-semibold text-textSecondary  ">
                        {' '}
                        <span>Bounty ID</span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                    <p className="text-sm   font-semibold text-textSecondary    ">
                        {' '}
                        <span> Bounty Title </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>

                    <p className="text-sm   font-semibold text-textSecondary    ">
                        {' '}
                        <span> Status </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                    <p className={`text-sm    font-semibold text-textSecondary   `}>
                        {' '}
                        <span> {activeTab === 'Projects' ? 'Project Title' : 'Event Title'} </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                    <p className="text-sm font-semibold text-textSecondary    ">
                        {' '}
                        <span> Validations </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                    <p className="text-sm  font-semibold text-textSecondary    ">
                        {' '}
                        <span>Start Date </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                    <p className="text-sm  font-semibold text-textSecondary    ">
                        {' '}
                        <span>Expiry Date </span>{' '}
                        {/* <span>
                            <SortIcon />
                        </span>{' '} */}
                    </p>
                </Table.Header>
                {isLoading ? (
                    <div className="min-h-[20vh] flex justify-center items-center">
                        <Loader />
                    </div>
                ) : filteredData.length ? (
                    filteredData.map((overviewrow) => (
                        <Table.Row key={overviewrow._id}>
                            <TruncatedTextWithTooltip
                                onClick={() => navigate(`/organizations/${id}/view-bounties/${overviewrow._id}${overviewrow?.eventName ? `?eventName=${overviewrow.eventName}` : ""}`)}
                                containerClassName={'self-center'}
                                textClassName="text-textBrandBlue font-medium truncate cursor-pointer"
                                text={overviewrow._id}
                            />
                            <TruncatedTextWithTooltip
                                onClick={() => {



                                    if (activeTab === "Projects") {
                                        navigate(`bounty-submissions/${overviewrow._id}?fromTab=projects&from=validation`);
                                    }
                                    else if (activeTab === 'Events') {
                                        navigate(`bounty-submissions/${overviewrow._id}?fromTab=events&from=validation`);
                                    }


                                }}
                                containerClassName={'self-center'}
                                textClassName="text-textBrandBlue font-medium truncate cursor-pointer"
                                text={overviewrow.title || '-'}
                            />
                            <PopOver
                                isValidationRequested={overviewrow.status === "Validation Requested"}
                                rounded="rounded-lg "
                                className="px-2 py-1 leading-3 self-center   "
                                textClassName="text-xs font-semibold"
                                bg={BOUNTY_STATUS_TAG_COLOR[overviewrow.status]?.bg}
                                textColor={BOUNTY_STATUS_TAG_COLOR[overviewrow.status]?.text}
                                borderColor={BOUNTY_STATUS_TAG_COLOR[overviewrow.status]?.border}
                                text={overviewrow.status}
                                active={
                                    overviewrow.status === 'Live and Published' ||
                                        overviewrow.status === 'Live and Unpublished'
                                        ? 'Live'
                                        : overviewrow.status
                                }
                            />
                            <p
                                onClick={() => {

                                    if (!overviewrow.projectId || !overviewrow.eventId) {
                                        return
                                    }

                                    if (activeTab === 'Projects') {
                                        navigate(`/organizations/${id}/view-projects/${overviewrow.projectId}`);
                                    } else {
                                        navigate(`/organizations/${id}/view-events/${overviewrow.eventId}`);
                                    }
                                }}
                                className={`  ${overviewrow.projectId || overviewrow.eventId ? "cursor-pointer text-textBrandBlue" : ""}  font-medium truncate `}
                            >
                                {activeTab === 'Projects' ? overviewrow?.projectTitle || "-" : overviewrow?.eventName || "-"}
                            </p>
                            <p className=" text-textPrimary  ">
                                {overviewrow.validatedSubmissionCount}/{overviewrow.totalSubmissionCount}
                            </p>
                            <p className=" text-textPrimary  ">{dmyFormat(overviewrow.startTimestamp)}</p>
                            <p className=" text-textPrimary  ">{dmyFormat(overviewrow.expirationTimestamp)}</p>
                        </Table.Row>
                    ))
                ) : (
                    <NoDataAvailable />
                )}

                {totalEntries > 10 && (
                    <div className="w-[100%] mx-auto">
                        <Pagination
                            className="pt-6 pb-[.65rem]"
                            hoverColor="hover:text-textPrimary"
                            currentColor="bg-neutral50D"
                            textActive="text-textPrimary"
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalEntries / pageEntries)}
                            entriesPerPage={pageEntries}
                            totalEntries={totalEntries}
                            entriesHandler={entriesHandler}
                            onPageChange={setCurrentPage}
                            border="border-borderUnderline"
                            hoverBorder="hover:border-borderUnderline"
                        />
                    </div>
                )}
            </Table>
        </div>
    );
}

export default ValidationOverview;
